import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from "../utils/utils";

@Pipe({
  standalone: true,
  name: 'size'
})
export class SizePipe implements PipeTransform {

  transform(size: number, sizeData: any = {}): string {
    return Utils.sizeToString(size, sizeData.unit);
  }

}
